export default "__VITE_ASSET__DaIhpV7x__"